import * as React from 'react';
/**
 *
 * Original name: Stacks
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=38434%3A10958
 *
 */
export const StacksSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m60 69.636-37.502-24.02L60 21.838l37.502 23.776L60 69.636Zm34.118-7.579L60 83.911 25.882 62.057l3.236-5.052L60 76.785l30.882-19.78 3.236 5.052ZM60 98.16l34.118-21.853-3.236-5.052L60 91.035l-30.882-19.78-3.236 5.052L60 98.16Z", fill: "currentColor" })));
